import { MdOutlineMail } from "react-icons/md";
import { FiPhoneCall } from "react-icons/fi";
import { FaInstagram } from "react-icons/fa";
import { SlSocialFacebook } from "react-icons/sl";
import { AiOutlineYoutube } from "react-icons/ai";
import { FaAngleDown } from "react-icons/fa6";
import FlagIcon from '../assets/images/flag.svg';
import { Link } from "react-router-dom";


const TopBar = () => {
  return (
    <>
        <section class="top_header d-none d-lg-block">
            <div class="main_marquee_tag w-full overflow-hidden relative py-[7px] bg-[#442202] text-white text-base font-bold whitespace-nowrap">
                <div class="container-fluid px-[15px]">
                    <div class="flex items-center justify-between w-full gap-3">
                        <div class="flex items-center  gap-2">
                            <Link to="mailto:gokartexp@gmail.com" class="main_top_box bg-[#ECECEC] rounded-full h-[25px] w-[25px] overflow-hidden flex justify-center items-center">
                                <MdOutlineMail className="text-brown"/>
                            </Link>
                            <Link to="tel:818058065253" class="main_top_box bg-[#ECECEC] rounded-full h-[25px] w-[25px] overflow-hidden flex justify-center items-center">
                                <FiPhoneCall className="text-brown"/>
                            </Link>
                        </div>
                        {/* <div class="main_marquee_tag w-full overflow-hidden relative py-[7px] bg-[#442202] text-white text-base font-bold whitespace-nowrap">
                            <div class="scrolling-track">
                                <div class="scrolling-text inline-block   whitespace-nowrap">Summer offers available on selected routes Jun 15 – Sep 15, 2026. Reserve your spot now!</div>
                            </div>
                        </div> */}
                        <div class="flex items-center gap-4">
                            <div class="flex items-center  gap-2">
                                <Link to="https://www.instagram.com/monkeyadventurekartjapan" class="main_top_box bg-[#ECECEC] rounded-full h-[25px] w-[25px] overflow-hidden flex justify-center items-center" target="_blank">
                                    <FaInstagram  className="text-[16px] text-brown"/>
                                </Link>
                                <Link to="https://www.facebook.com/monkeykartshinjuku/" class="main_top_box bg-[#ECECEC] rounded-full h-[25px] w-[25px] overflow-hidden flex justify-center items-center" target="_blank">
                                    <SlSocialFacebook  className="text-[16px] text-brown"/>
                                </Link>
                                <Link to="https://www.youtube.com/@monkeyadventurekartjapan" class="main_top_box bg-[#ECECEC] rounded-full h-[25px] w-[25px] overflow-hidden flex justify-center items-center" target="_blank">
                                    <AiOutlineYoutube  className="text-[16px] text-brown"/>
                                </Link>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
};

export default TopBar;
